export default __webpack_public_path__ + "static/media/8thwall.4d2f8ce9.svg";